import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      videoList: [],
      video: { videos: [] },
      chapter: { name: "", collect: false, collectNum: 0, vcId: 0 },
      loadingVideo: true,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "application/x-mpegURL", // 按实际地址动态覆盖，兼容 m3u8/mp4
            src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      timer: null,
      counter: 0, // 秒
      pendingResumeSecond: 0,
      resumePrompted: false
    };
  },
  computed: {
    chapterRows() {
      return Array.isArray(this.video && this.video.videos)
        ? this.video.videos
        : [];
    }
  },
  created: function() {
    // 加载课程和课程列表
    this.loadVideoData();
  },
  beforeRouteLeave: function(to, from, next) {
    this.clearReportTimer();
    next();
  },
  methods: {
    getRouteArId() {
      const arId = Number(this.$route.query.arId);
      return Number.isFinite(arId) && arId > 0 ? String(arId) : "";
    },
    getChapterArId(chapter) {
      const routeArId = this.getRouteArId();
      if (routeArId) {
        return routeArId;
      }
      const applyArId = Number(chapter && chapter.apply && chapter.apply.arId);
      return Number.isFinite(applyArId) && applyArId > 0 ? String(applyArId) : "";
    },
    getCurrentPlayer() {
      const playerRef = this.$refs.videoPlayer;
      return playerRef && playerRef.player ? playerRef.player : null;
    },
    getCurrentPlaybackSecond() {
      const player = this.getCurrentPlayer();
      if (!player || typeof player.currentTime !== "function") {
        return 0;
      }
      const currentTime = Math.floor(Number(player.currentTime()));
      return Number.isFinite(currentTime) && currentTime > 0 ? currentTime : 0;
    },
    clearReportTimer() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async reportDuration() {
      const courseId = Number(this.chapter && this.chapter.vcId);
      if (!Number.isFinite(courseId) || courseId <= 0) {
        return;
      }

      const lastSchedule = this.getCurrentPlaybackSecond();
      if (lastSchedule <= 0) {
        return;
      }

      const arId = this.getChapterArId(this.chapter);
      const params = {
        courseId,
        lastSchedule,
        arId: arId || 0
      };
      await httpRequest("/app/course/duration", "put", params);
    },
    resolveVideoSource(rawUrl) {
      const src = (rawUrl || "").trim();
      if (!src) {
        return { src: "", type: "application/x-mpegURL" };
      }
      const lower = src.toLowerCase();
      const type = lower.includes(".m3u8")
        ? "application/x-mpegURL"
        : "video/mp4";
      return { src, type };
    },
    normalizeVideoList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === "object") {
        if (Array.isArray(data.list)) {
          return data.list;
        }
        if (Array.isArray(data.records)) {
          return data.records;
        }
        if (Array.isArray(data.items)) {
          return data.items;
        }
      }
      return [];
    },
    resolveChapterRowsFromCourseList(courseList, targetVcId, sectionCsId) {
      if (!Array.isArray(courseList) || courseList.length < 1) {
        return [];
      }

      const hasGroupStructure = courseList.some(
        item => Array.isArray(item && item.videos) && item.videos.length > 0
      );

      if (!hasGroupStructure) {
        // 兼容后端返回扁平课程列表
        return courseList.slice();
      }

      const currentVcId = Number(targetVcId);
      const currentCsId = Number(sectionCsId);
      const targetCourse = courseList.find(item => {
        if (!Array.isArray(item && item.videos) || item.videos.length < 1) {
          return false;
        }
        if (
          Number.isFinite(currentVcId) &&
          item.videos.some(video => Number(video && video.vcId) === currentVcId)
        ) {
          return true;
        }
        if (
          Number.isFinite(currentCsId) &&
          item.videos.some(video => Number(video && video.csId) === currentCsId)
        ) {
          return true;
        }
        return false;
      });

      if (targetCourse && Array.isArray(targetCourse.videos)) {
        return targetCourse.videos.slice();
      }

      for (let i = 0; i < courseList.length; i += 1) {
        const row = courseList[i];
        if (Array.isArray(row && row.videos) && row.videos.length > 0) {
          return row.videos.slice();
        }
      }
      return [];
    },
    mergeChapterCourseMeta(source) {
      if (!source) {
        return source;
      }
      const sourceVcId = Number(source && source.vcId);
      if (!Number.isFinite(sourceVcId) || sourceVcId <= 0) {
        return source;
      }
      const matched = this.videoList.find(
        item => Number(item && item.vcId) === sourceVcId
      );
      if (!matched) {
        return source;
      }
      return {
        ...matched,
        ...source,
        apply: source.apply || matched.apply,
        learn: source.learn || matched.learn,
        schedule: source.schedule || matched.schedule
      };
    },
    updateResumeState(chapter) {
      const resumeSecond = Number(
        chapter && chapter.schedule && chapter.schedule.lastSchedule
      );
      this.pendingResumeSecond =
        Number.isFinite(resumeSecond) && resumeSecond > 0 ? resumeSecond : 0;
      this.resumePrompted = false;
    },
    syncDirectoryRows(sectionCsId) {
      let rows = this.chapterRows;
      if (!Array.isArray(rows) || rows.length < 1) {
        rows = [];
      }

      const fallbackRows = this.resolveChapterRowsFromCourseList(
        this.videoList,
        Number(this.chapter && this.chapter.vcId),
        sectionCsId
      );

      if (fallbackRows.length > rows.length) {
        rows = fallbackRows;
      }

      if (rows.length < 1 && this.chapter && this.chapter.vcId) {
        rows = [this.chapter];
      }

      rows = rows.map(row => this.mergeChapterCourseMeta(row));
      this.chapter = this.mergeChapterCourseMeta(this.chapter);
      this.updateResumeState(this.chapter);

      this.video = {
        ...(this.video || {}),
        videos: rows
      };
    },
    applyChapterToPlayer(chapter) {
      if (!chapter) {
        return;
      }
      this.chapter = this.mergeChapterCourseMeta(chapter);
      this.updateResumeState(this.chapter);

      const source = this.resolveVideoSource(this.chapter.videoUrl);
      const src = source.src;
      const type = source.type;
      const poster = this.chapter.thumbUrl || "";
      this.playerOptions.sources[0].src = src;
      this.playerOptions.sources[0].type = type;
      this.playerOptions.poster = poster;

      const player = this.getCurrentPlayer();
      if (!player) {
        return;
      }

      try {
        player.pause();
      } catch (error) {
        void error;
      }
      const playerRef = this.$refs.videoPlayer;
      playerRef.options.sources[0].src = src;
      playerRef.options.sources[0].type = type;
      playerRef.options.poster = poster;
      this.$nextTick(() => {
        try {
          player.play();
        } catch (error) {
          void error;
        }
      });
    },
    async loadVideoData() {
      const loadingInstance = this.$loading({ text: "加载中" });
      try {
        const vcId = Number(this.$route.query.vcId);
        if (!Number.isFinite(vcId) || vcId <= 0) {
          this.$message.warning("课程信息异常");
          return;
        }

        const routeArId = this.getRouteArId();
        let res = await httpRequest("/app/course/video/" + vcId, "get", {
          arId: routeArId || ""
        });
        if (res !== null && res !== undefined && res.code === 200 && res.data) {
          this.chapter = res.data;
          const source = this.resolveVideoSource(this.chapter.videoUrl || "");
          this.playerOptions.sources[0].src = source.src;
          this.playerOptions.sources[0].type = source.type;
          this.playerOptions.poster = this.chapter.thumbUrl || "";
        } else {
          this.$message.warning((res && res.message) || "课程不存在或已下线");
          return;
        }

        const routeCsId = Number(this.$route.query.csId);
        const chapterCsId = Number(this.chapter && this.chapter.csId);
        const sectionCsId =
          Number.isFinite(routeCsId) && routeCsId > 0
            ? routeCsId
            : Number.isFinite(chapterCsId) && chapterCsId > 0
            ? chapterCsId
            : null;

        if (sectionCsId) {
          res = await httpRequest(
            "/app/course/video/section/" + sectionCsId,
            "get",
            null
          );
          if (
            res !== null &&
            res !== undefined &&
            res.code === 200 &&
            res.data
          ) {
            this.video = res.data;
          } else {
            this.video = { videos: [this.chapter] };
          }
        } else {
          this.video = { videos: [this.chapter] };
        }

        // 请求同专业课程列表（用于课程目录兜底）
        const majorId = Number(this.chapter && this.chapter.majorId);
        if (Number.isFinite(majorId) && majorId > 0) {
          res = await httpRequest("/app/course/video/courses", "get", {
            majorId
          });
          if (res !== null && res !== undefined && res.code === 200) {
            this.videoList = this.normalizeVideoList(res.data);
          } else {
            this.videoList = [];
          }
        } else {
          this.videoList = [];
        }

        // 兼容 section 接口不可用时，用 courses 返回数据补齐课程目录
        this.syncDirectoryRows(sectionCsId);
      } finally {
        loadingInstance.close();
      }
    },
    onPlayerPlay() {
      this.clearReportTimer();
      const _this = this;
      this.timer = setInterval(async function() {
        if (_this.counter >= 60) {
          await _this.reportDuration().catch(() => {});
          _this.counter = 0;
        } else {
          _this.counter++;
        }
      }, 1000);
    },
    onPlayerPause() {
      this.clearReportTimer();
    },
    onPlayerEnded() {
      this.clearReportTimer();
      this.counter = 0;
    },
    onPlayerWaiting() {
      this.loadingVideo = true;
    },
    onPlayerCanplay() {
      this.loadingVideo = false;
    },
    onPlayerPlaying() {
      this.loadingVideo = false;
    },
    onPlayerSeeked() {
      this.loadingVideo = false;
    },
    onPlayerLoadeddata() {
      this.loadingVideo = false;
      if (this.resumePrompted || this.pendingResumeSecond <= 0) {
        return;
      }
      const player = this.getCurrentPlayer();
      if (!player || typeof player.currentTime !== "function") {
        return;
      }
      this.resumePrompted = true;
      try {
        player.pause();
      } catch (error) {
        void error;
      }
      this.$confirm(
        `您上次观看到 ${this.getDuration(this.pendingResumeSecond)}，是否继续观看？`,
        "提示",
        {
          confirmButtonText: "继续观看",
          cancelButtonText: "从头开始",
          type: "info"
        }
      )
        .then(() => {
          try {
            player.currentTime(this.pendingResumeSecond);
            player.play();
          } catch (error) {
            void error;
          }
        })
        .catch(() => {
          try {
            player.currentTime(0);
            player.play();
          } catch (error) {
            void error;
          }
        });
    },
    async toggleColection() {
      const params = {
        vcId: this.chapter.vcId,
        validFlag: !this.chapter.collect
      };
      const res = await httpRequest("/app/course/collect", "put", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.chapter.collect = !this.chapter.collect;
        this.chapter.collectNum = this.chapter.collect
          ? this.chapter.collectNum + 1
          : this.chapter.collectNum - 1;
        this.$message.success(this.chapter.collect ? "已收藏" : "已取消收藏");
      }
    },
    getDuration(duration) {
      const hourStr =
        duration / 3600 < 10
          ? "0" + parseInt(duration / 3600)
          : parseInt(duration / 3600);
      duration = duration % 3600;
      const minStr =
        duration / 60 < 10
          ? "0" + parseInt(duration / 60)
          : parseInt(duration / 60);
      const secStr = duration % 60 < 10 ? "0" + (duration % 60) : duration % 60;
      return hourStr + ":" + minStr + ":" + secStr;
    },
    changeChapter(chapterIdx) {
      this.clearReportTimer();
      this.counter = 0;
      const target = this.chapterRows[chapterIdx];
      if (!target) {
        return;
      }
      this.applyChapterToPlayer(target);
    }
  }
};
